var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.4,419.05c83.79,43.77,219.63,43.77,303.42,0s83.78-114.74,0-158.51-219.63-43.77-303.42,0S17.62,375.28,101.4,419.05Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.94,300.85c-12.7,6-33.29,6-46,0s-12.7-15.86,0-21.92,33.28-6.05,46,0S435.63,294.8,422.94,300.85Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.63,335.89s1-14.74-4.13-27.26-13.71-21.32-22.78-23.74-18.06,4.69-9.28,12.32,25.2,16.76,29.27,40Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.63,335.89s1-14.74-4.13-27.26-13.71-21.32-22.78-23.74-18.06,4.69-9.28,12.32,25.2,16.76,29.27,40Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.28,337h0a.5.5,0,0,1-.48-.51c.61-17.38-11.9-42.06-28.93-47.84a.5.5,0,0,1,.33-.95c17.42,5.92,30.22,31.1,29.6,48.82A.5.5,0,0,1,89.28,337Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.88,371.29a10.69,10.69,0,0,1-4.88,1.3,14.31,14.31,0,0,1-5.9-.89c-3.34-1.26-6.14-3.18-7-6.8-.67-2.85.39-6.06-.86-8.79s-5-4.35-7.53-5.16c-1.79-.57-3.67-.85-5.43-1.51a7,7,0,0,1-4.17-3.57c-1.69-4.14,2.92-8.84,1.41-13.06-.75-2.09-2.8-3.38-4.67-4.57s-3.87-2.62-4.39-4.78a6.18,6.18,0,0,1,1.86-5.5c3.36-3.46,9-3.8,13.5-2.08a40.25,40.25,0,0,0,4.26,1.65c5.68,1.49,11.72-2.23,17.42-.89a10.33,10.33,0,0,1,7.54,7.63c.27,1.24.31,2.53.6,3.77.73,3.11,4,3.77,4.8,7,.71,2.88-.19,5.92-.69,8.77-.76,4.37-1.62,8.72-2.53,13.06q-.73,3.54-1.51,7.08c-.48,2.16.15,4.54-.82,6.53A10.89,10.89,0,0,1,89.88,371.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.48,355.89a.5.5,0,0,1-.49-.43c-2.4-15.53-24.25-33.9-38.2-35.76a.5.5,0,0,1,.13-1c14.27,1.91,36.6,20.71,39.05,36.61a.49.49,0,0,1-.41.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.72,334.63h0a.5.5,0,0,1-.45-.54C79.15,324,82.79,320.14,83,320a.5.5,0,1,1,.71.7s-3.55,3.8-4.44,13.5A.51.51,0,0,1,78.72,334.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.19,342.73a.51.51,0,0,1-.46-.31.49.49,0,0,1,.27-.65c.46-.2,11.35-4.76,20.87-2.18a.5.5,0,1,1-.26,1c-9.18-2.49-20.11,2.09-20.22,2.14A.71.71,0,0,1,63.19,342.73Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-1--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.63,167.78V371.85a3.85,3.85,0,0,0,1.73,3L97,377.54a3.83,3.83,0,0,0,3.46,0L316.37,252.89a3.85,3.85,0,0,0,1.73-3V45.83A9.31,9.31,0,0,0,314,38.48a9.27,9.27,0,0,0-8.39.15L95,160.28A9.53,9.53,0,0,0,90.63,167.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.78,169.83l-10.89-6.31a8.83,8.83,0,0,0-1.26,4.26V371.85a3.85,3.85,0,0,0,1.73,3L97,377.54a3.83,3.83,0,0,0,3.46,0l2.33-1.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.77,43.33,103.08,165a9.56,9.56,0,0,0-4.33,7.5V376.54c0,1.1.78,1.55,1.73,1L316.37,252.89a3.85,3.85,0,0,0,1.73-3V45.83C318.1,43.07,316.16,42,313.77,43.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.77,43.33,103.08,165a9.56,9.56,0,0,0-4.33,7.5V376.54c0,1.1.78,1.55,1.73,1L316.37,252.89a3.85,3.85,0,0,0,1.73-3V45.83C318.1,43.07,316.16,42,313.77,43.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.1,54.9V45.82c0-2.75-1.94-3.87-4.33-2.49L103.08,165a9.56,9.56,0,0,0-4.33,7.5v9.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.32,56.29a.29.29,0,0,1-.16,0,.36.36,0,0,1-.18-.49l1.54-3.27a.38.38,0,0,1,.68.32l-1.54,3.27A.39.39,0,0,1,309.32,56.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22,56.5a.41.41,0,0,1-.18,0,.36.36,0,0,1-.19-.36L309,54a.37.37,0,0,1,.4-.34.37.37,0,0,1,.34.41l-.11,1.18.58-.47a.39.39,0,0,1,.53.06.38.38,0,0,1,0,.53l-1.28,1A.33.33,0,0,1,309.22,56.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.48,51.71a.47.47,0,0,1-.16,0,.37.37,0,0,1-.18-.5l1.55-3.26a.36.36,0,0,1,.49-.18.37.37,0,0,1,.18.5l-1.54,3.26A.37.37,0,0,1,311.48,51.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.93,50.3h0a.37.37,0,0,1-.34-.41l.11-1.18-.58.47a.38.38,0,0,1-.48-.59l1.28-1a.36.36,0,0,1,.41,0,.36.36,0,0,1,.19.36L313.31,50A.38.38,0,0,1,312.93,50.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.91,166.29a4.49,4.49,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.47,4.47,0,0,0,2-3.51C110.94,166.17,110,165.65,108.91,166.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,161.62a4.49,4.49,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C119.06,161.5,118.15,161,117,161.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.15,156.94a4.51,4.51,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.46,4.46,0,0,0,2-3.51C127.19,156.82,126.28,156.3,125.15,156.94Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.2,176.3h22a2.9,2.9,0,0,0,2.9-2.9V134.26a13.92,13.92,0,0,0-13.92-13.92h0a13.92,13.92,0,0,0-13.92,13.92V173.4A2.9,2.9,0,0,0,386.2,176.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,125.83l3.37-1.81a1.85,1.85,0,0,0-2.55-.84A2,2,0,0,0,408,125.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.8,126.21l3.58,1.34a1.85,1.85,0,0,0-1.05-2.47A2,2,0,0,0,407.8,126.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.39,151.74l-10.22-.29c-.69-.58-11.43-12.7-11.43-12.7s-3.86,6.09-3.93,6.48,10.53,11.72,11.58,12.86a3.15,3.15,0,0,0,2.5,1.22c2.77.17,13.14.9,13.14.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,161.54l-16.91-.73c-1.5-2.05-1.46-7.49.05-9.23l18.72.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,161.54l-16.91-.73c-1.5-2.05-1.46-7.49.05-9.23l18.72.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,161.54l-16.91-.73c-1.5-2.05-1.46-7.49.05-9.23l18.72.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,134.87c2-.22,3.33-1.7,3.78-1.29A1.11,1.11,0,0,1,360,135a13.72,13.72,0,0,1-3,1.73,22.85,22.85,0,0,0-.54,3.09c-.17,1.53-.11,4.58-1.42,5.63-3.91,3.13-4.91-1.84-4.75-5.18C350.53,136.15,354.11,135.1,356.2,134.87Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.08,275.2a3.39,3.39,0,0,1-.49,1.93,25.12,25.12,0,0,1-3.18,4.17c-1.7,1.82-4.25,4-6.07,5.57-1,.89-1,2.23.4,2.7a10.87,10.87,0,0,0,8-1.12c1.81-1,4.39-5.46,5.9-6.14,1.73-.78,2.7-1.18,3.29-2a2.81,2.81,0,0,0,.35-3.48c-.82-1.52-2-3.86-2.55-3.6l.16.48c-.4,1.24-3.77,2.68-5.51,2.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.55,269.22a39,39,0,0,1,1.52,6,3.16,3.16,0,0,1-.48,1.91,24.69,24.69,0,0,1-3.19,4.17c-.82.89-1.85,1.86-2.9,2.79a.92.92,0,0,0-.15.45c0,.94,2.31,1.2,3.66.8a8.51,8.51,0,0,0,4.17-3.2c.78-1,2.53-3,3.64-4.53a7.75,7.75,0,0,0,1-1.5,3.11,3.11,0,0,0,.14-2.15l-.07-.22a23.8,23.8,0,0,1-1.1-5.73",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.57,277.27a32.13,32.13,0,0,0-.44,5.27v3.91h-5.79v-6.66l-.08,0s-.1-1.31-.26-3.36",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.55,269.22c-3.2-10.35-10.32-28.88-11.3-32.13-1-3.46.22-33.75,1.06-43.45L413.5,192c2.3,9.84.06,23.1-.73,31.39-.76,8.06-1.71,17.48-1.71,17.48s2.36,8.22,1.73,14.76c-.4,4.12-2.34,16.3-3.22,21.62a8.37,8.37,0,0,1-6.57-.88c-.37-4.67-1.07-13.18-1.73-18.74-1-8.36-1.33-14.46-2.19-19.34-1.07-6.08-1.45-29.94-1.45-29.94l-3.47,27.06a34.08,34.08,0,0,1,3.11,8c1,3.85,2.06,18.29,2.49,24.54A9.27,9.27,0,0,1,393.55,269.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.63,208.37s-5.51-1.94-8.65-4.82a15.44,15.44,0,0,0,6.46,5.66l.05,15.84,2.14-16.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,152.22s8.2.94,9.18,1.38c-5,5.47.32,10,.32,10l-4.74,16.68c3.28,4.2,6.09,7.49,6.88,12.5-3.52,6.19-23.25,7.05-30.49,2.43.63-8.64,2-14.82,1.57-17.42-3.45-10.61-2.37-12.83-2.05-15.25.63-4.73,5.33-8.86,8-10.59h2.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.33,283.6v-.83a16,16,0,0,1-4.14,7.25c-1.83,1.67-4.32,3.59-4.95,5.45s2.94,2.7,5.3,2.47a9.51,9.51,0,0,0,5.95-3.12c1.51-1.72,1.48-2.9,2.18-3.85s2.32-2,2.7-3.11a7,7,0,0,0-.33-3c-.27-1-.56-2.15-.91-2.05v.63a4.63,4.63,0,0,1-2.9,1C405.38,284.41,403.33,284.24,403.33,283.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.13,283.4a4.63,4.63,0,0,1-2.9,1c-.85,0-2.9-.14-2.9-.78v-.83a16,16,0,0,1-4.14,7.25l-1.39,1.24c-1,1.08-.7,2,1.59,2.22s4.29-1.18,6-3.3A37.17,37.17,0,0,0,409.13,283.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.87,127.16c-1.47.87-3.29,4.57-3.11,12.32.15,6.57,2.28,8.19,3.35,8.66s3.14.18,5.14-.15v3.94s-2.77,3.22-2.6,5,4,2.24,6.6.47a21.12,21.12,0,0,0,4.78-5.21l0-9.07s1.18,1.15,3.18-.6c1.65-1.45,2.21-3.88.92-5.19a2.89,2.89,0,0,0-4.58.91s-1.11-3.09-5.73-4.6C391.6,132.31,389.33,130.74,387.87,127.16Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.1,137.83a.83.83,0,0,0,.78.89.86.86,0,1,0-.78-.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.88,143.4,390,144a1,1,0,0,0,1.25.69A1.05,1.05,0,0,0,391.88,143.4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.32,135.29l1.68-1.16a1,1,0,0,0-1.39-.28A1.07,1.07,0,0,0,385.32,135.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,135.9l-1.67-1.16a1,1,0,0,1,1.39-.28A1.06,1.06,0,0,1,394.5,135.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.71,137.23a.84.84,0,0,0,.78.9.86.86,0,1,0-.78-.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.61 136.76 389.48 141.73 386.86 140.92 389.61 136.76",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.25,148c2.11-.28,6.46-1.53,7.14-3.25a4.46,4.46,0,0,1-1.53,2.2c-1.29,1.11-5.61,2.37-5.61,2.37Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.9 172.88 402.43 183.09 406.79 180.29 408.9 172.88",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "408.9 172.88 402.43 183.09 406.79 180.29 408.9 172.88"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M117.33,389.26l-.6-.34a3.85,3.85,0,0,1-1.73-3V216.37a3.82,3.82,0,0,1,1.73-3L227,149.7a3.82,3.82,0,0,0,1.74-3V136.63a3.84,3.84,0,0,1,1.73-3l49.34-28.48a3.77,3.77,0,0,1,3.46,0l.6.34a3.82,3.82,0,0,1,1.73,3v5.38c0,1.11.78,1.55,1.74,1l45.28-26.14a3.83,3.83,0,0,1,3.46,0l.6.35a3.81,3.81,0,0,1,1.73,3V261.62a3.81,3.81,0,0,1-1.73,3L120.79,389.26A3.77,3.77,0,0,1,117.33,389.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.06,388.26V218.72a3.83,3.83,0,0,1,1.73-3l110.28-63.67a3.85,3.85,0,0,0,1.73-3V139a3.81,3.81,0,0,1,1.73-3l49.34-28.49c1-.55,1.73-.1,1.73,1v10.07c0,1.11.78,1.55,1.74,1l49.34-28.48c1-.56,1.73-.11,1.73,1V261.62a3.81,3.81,0,0,1-1.73,3L120.79,389.26C119.84,389.82,119.06,389.37,119.06,388.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,227v1.47l4.06,2.35L338.41,104.15V92.07a3.86,3.86,0,0,0-1.73-3l-.6-.34a3.83,3.83,0,0,0-3.46,0l-45.29,26.14c-.95.55-1.73.11-1.73-1v-5.38a3.82,3.82,0,0,0-1.73-3l-.6-.34a3.77,3.77,0,0,0-3.46,0l-49.34,28.48a3.85,3.85,0,0,0-1.74,3V146.7a3.81,3.81,0,0,1-1.73,3L116.73,213.37a3.82,3.82,0,0,0-1.73,3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,227v1.47l4.06,2.35L338.41,104.15V92.07a3.86,3.86,0,0,0-1.73-3l-.6-.34a3.83,3.83,0,0,0-3.46,0l-45.29,26.14c-.95.55-1.73.11-1.73-1v-5.38a3.82,3.82,0,0,0-1.73-3l-.6-.34a3.77,3.77,0,0,0-3.46,0l-49.34,28.48a3.85,3.85,0,0,0-1.74,3V146.7a3.81,3.81,0,0,1-1.73,3L116.73,213.37a3.82,3.82,0,0,0-1.73,3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,153.39V139.32l-7.62-4.39a3.55,3.55,0,0,0-.51,1.7V146.7a3.54,3.54,0,0,1-.5,1.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.12,219.06l-7.61-4.4a3.51,3.51,0,0,0-.51,1.71v12.07l4.06,2.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.07,152.05,120.79,215.72a3.83,3.83,0,0,0-1.73,3v12.07L338.41,104.15V92.07c0-1.1-.78-1.55-1.73-1l-49.35,28.49c-.95.56-1.73.11-1.73-1V108.49c0-1.1-.77-1.55-1.73-1L234.53,136a3.81,3.81,0,0,0-1.73,3v10.07A3.85,3.85,0,0,1,231.07,152.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.81,216.68l-3.55,2,1.36-2.34a.5.5,0,1,0-.86-.5l-2.31,4a.46.46,0,0,0,0,.38.45.45,0,0,0,.24.3l2.31,1.3a.42.42,0,0,0,.24.07.52.52,0,0,0,.44-.26.51.51,0,0,0-.19-.68l-1.55-.87,4.42-2.55a.5.5,0,1,0-.5-.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.08,212.62a.52.52,0,0,0-.23-.31l-2.31-1.3a.5.5,0,1,0-.49.88l1.54.86-4.42,2.56a.51.51,0,0,0-.19.68.51.51,0,0,0,.44.25.57.57,0,0,0,.25-.06l3.55-2.06-1.36,2.34a.51.51,0,0,0,.18.69.55.55,0,0,0,.25.07.5.5,0,0,0,.43-.25l2.31-4A.46.46,0,0,0,138.08,212.62Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,206.08l158.16-91.3c1.19-.69,2.16-.2,2.16,1.09a4.65,4.65,0,0,1-2.16,3.6L145.6,210.78c-1.19.69-2.16.2-2.16-1.1A4.67,4.67,0,0,1,145.6,206.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,110c1.13-.65,2-.12,2,1.17a4.47,4.47,0,0,1-2,3.52c-1.12.65-2,.12-2-1.17A4.49,4.49,0,0,1,312,110Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.14,105.32c1.12-.65,2-.12,2,1.17a4.49,4.49,0,0,1-2,3.52c-1.12.65-2,.12-2-1.17A4.49,4.49,0,0,1,320.14,105.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.26,100.63c1.12-.65,2-.12,2,1.17a4.49,4.49,0,0,1-2,3.52c-1.12.65-2,.12-2-1.17A4.49,4.49,0,0,1,328.26,100.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245,137c0,1.29,1,1.78,2.17,1.09l24.1-13.91a4.64,4.64,0,0,0,2.17-3.6c0-1.29-1-1.78-2.17-1.09l-24.1,13.91A4.64,4.64,0,0,0,245,137Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.89,138.15a4.49,4.49,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C240.92,138,240,137.5,238.89,138.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.54,118.72a.59.59,0,0,1-.25-.07l-4.06-2.35a.5.5,0,1,1,.5-.86l4.06,2.34a.51.51,0,0,1,.18.69A.5.5,0,0,1,281.54,118.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.48,121.06a.45.45,0,0,1-.25-.07.49.49,0,0,1-.18-.68l4.06-7a.5.5,0,1,1,.86.5l-4.06,7A.5.5,0,0,1,277.48,121.06Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.52,396.3l-.6-.35a3.81,3.81,0,0,1-1.73-3V223.41a3.82,3.82,0,0,1,1.74-3l57.46-33.18a3.83,3.83,0,0,0,1.74-3V174.16a3.78,3.78,0,0,1,1.73-3l49.34-28.49a3.83,3.83,0,0,1,3.46,0l.6.35a3.81,3.81,0,0,1,1.73,3v5.38c0,1.1.78,1.55,1.74,1L344.8,95.76a3.86,3.86,0,0,1,3.47,0l.59.35a3.83,3.83,0,0,1,1.74,3V268.66a3.85,3.85,0,0,1-1.74,3L133,396.3A3.83,3.83,0,0,1,129.52,396.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.25,395.3V225.75a3.82,3.82,0,0,1,1.73-3l57.47-33.18a3.83,3.83,0,0,0,1.73-3V176.5a3.84,3.84,0,0,1,1.73-3L243.25,145c1-.56,1.73-.11,1.73,1v10.07c0,1.1.78,1.55,1.74,1l102.14-59c1-.55,1.74-.1,1.74,1V268.66a3.85,3.85,0,0,1-1.74,3L133,396.3C132,396.85,131.25,396.4,131.25,395.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,234v1.48l4.06,2.34L350.6,111.18V99.11a3.83,3.83,0,0,0-1.74-3l-.59-.35a3.86,3.86,0,0,0-3.47,0L246.72,152.4c-1,.55-1.74.1-1.74-1V146a3.81,3.81,0,0,0-1.73-3l-.6-.35a3.83,3.83,0,0,0-3.46,0l-49.34,28.49a3.82,3.82,0,0,0-1.74,3v10.07a3.83,3.83,0,0,1-1.74,3l-57.46,33.18a3.81,3.81,0,0,0-1.73,3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.24,190.92V176.85l-7.62-4.4a3.59,3.59,0,0,0-.51,1.71v10.07a3.62,3.62,0,0,1-.51,1.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.31,226.1l-7.62-4.4a3.54,3.54,0,0,0-.5,1.71v12.07l4.06,2.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.45,189.57,133,222.75a3.82,3.82,0,0,0-1.73,3v12.07L350.6,111.18V99.11c0-1.1-.78-1.55-1.74-1l-102.14,59c-1,.55-1.74.1-1.74-1V146c0-1.11-.77-1.56-1.73-1L193.91,173.5a3.84,3.84,0,0,0-1.73,3v10.07A3.83,3.83,0,0,1,190.45,189.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142,223.72l-3.55,2.05,1.36-2.34a.5.5,0,1,0-.86-.5l-2.31,4a.52.52,0,0,0-.06.38.57.57,0,0,0,.24.31l2.31,1.3a.54.54,0,0,0,.25.06.5.5,0,0,0,.24-.93l-1.54-.87,4.42-2.56a.5.5,0,0,0-.5-.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.27,219.65a.48.48,0,0,0-.24-.3l-2.31-1.3a.5.5,0,0,0-.68.19.5.5,0,0,0,.19.68l1.55.87-4.43,2.56a.5.5,0,0,0,.25.93.45.45,0,0,0,.25-.07l3.56-2.05-1.36,2.34a.49.49,0,0,0,.18.68.43.43,0,0,0,.25.07.5.5,0,0,0,.43-.25l2.31-4A.49.49,0,0,0,150.27,219.65Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,213.12l158.15-91.31c1.2-.69,2.17-.2,2.17,1.1a4.64,4.64,0,0,1-2.17,3.59L157.79,217.81c-1.19.69-2.16.2-2.16-1.09A4.65,4.65,0,0,1,157.79,213.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.2,117c1.12-.64,2-.12,2,1.18a4.47,4.47,0,0,1-2,3.51c-1.12.65-2,.13-2-1.17A4.51,4.51,0,0,1,324.2,117Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.32,112.35c1.13-.64,2-.12,2,1.18a4.46,4.46,0,0,1-2,3.51c-1.12.65-2,.13-2-1.17A4.51,4.51,0,0,1,332.32,112.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.45,107.66c1.12-.64,2-.12,2,1.18a4.47,4.47,0,0,1-2,3.51c-1.12.65-2,.13-2-1.17A4.51,4.51,0,0,1,340.45,107.66Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.36,174.5c0,1.3,1,1.79,2.17,1.1l24.1-13.92a4.64,4.64,0,0,0,2.17-3.59c0-1.3-1-1.79-2.17-1.1l-24.1,13.92A4.64,4.64,0,0,0,204.36,174.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.27,175.67a4.51,4.51,0,0,0-2,3.52c0,1.3.91,1.82,2,1.17a4.47,4.47,0,0,0,2-3.51C200.3,175.55,199.39,175,198.27,175.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.92,156.24a.47.47,0,0,1-.25-.07l-4.06-2.34a.5.5,0,0,1,.5-.87l4.06,2.35a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,158.59a.55.55,0,0,1-.25-.07.5.5,0,0,1-.18-.68l4.06-7a.5.5,0,1,1,.86.5l-4.06,7A.5.5,0,0,1,236.86,158.59Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.7,403.33l-.59-.34a3.83,3.83,0,0,1-1.74-3V230.44a3.85,3.85,0,0,1,1.73-3l4.66-2.69a3.81,3.81,0,0,0,1.73-3V211.68a3.83,3.83,0,0,1,1.74-3l49.34-28.49a3.83,3.83,0,0,1,3.46,0l.6.35a3.81,3.81,0,0,1,1.73,3v5.38c0,1.1.78,1.55,1.73,1L357,102.8a3.83,3.83,0,0,1,3.46,0l.6.35a3.81,3.81,0,0,1,1.73,3V275.69a3.81,3.81,0,0,1-1.73,3L145.17,403.33A3.79,3.79,0,0,1,141.7,403.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.44,402.33V232.79a3.82,3.82,0,0,1,1.74-3l4.66-2.69a3.85,3.85,0,0,0,1.73-3V214a3.81,3.81,0,0,1,1.73-3l49.34-28.49c1-.55,1.73-.11,1.73,1v10.07c0,1.11.78,1.55,1.73,1l155-89.46c1-.56,1.73-.11,1.73,1V275.69a3.81,3.81,0,0,1-1.73,3L145.17,403.33C144.21,403.89,143.44,403.44,143.44,402.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.43 244.86 143.44 277.69 362.78 151.05 362.78 118.22 143.43 244.86",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.37 242.51 139.37 275.35 143.44 277.69 143.43 244.86 139.37 242.51",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.37 242.51 139.37 275.35 143.44 277.69 143.43 244.86 139.37 242.51",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.65,217.81l71-41v4.69l-71,41c-1.2.69-2.17.2-2.17-1.09A4.65,4.65,0,0,1,214.65,217.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,173.33l-6.09,3.52v4.69L291.7,178a4.49,4.49,0,0,0,2-3.52C293.73,173.21,292.82,172.68,291.7,173.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.62,280c2.24-1.3,4.06-.25,4.06,2.34a9,9,0,0,1-4.06,7c-2.24,1.29-4.06.24-4.06-2.35A9,9,0,0,1,155.62,280Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,274.1,190,260.18c1.19-.69,2.16-.2,2.16,1.1a4.65,4.65,0,0,1-2.16,3.59l-24.11,13.92c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,165.91,274.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,283.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,284.45,163.75,284.2,163.75,283.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,283.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,284.45,163.75,284.2,163.75,283.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.62,298c2.24-1.3,4.06-.25,4.06,2.34a9,9,0,0,1-4.06,7c-2.24,1.29-4.06.24-4.06-2.35A9,9,0,0,1,155.62,298Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,292.1,190,278.18c1.19-.69,2.16-.2,2.16,1.1a4.65,4.65,0,0,1-2.16,3.59l-24.11,13.92c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,165.91,292.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,301.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,302.45,163.75,302.2,163.75,301.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,301.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,302.45,163.75,302.2,163.75,301.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.62,318c2.24-1.3,4.06-.25,4.06,2.34a9,9,0,0,1-4.06,7c-2.24,1.29-4.06.24-4.06-2.35A9,9,0,0,1,155.62,318Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,312.1,190,298.18c1.19-.69,2.16-.2,2.16,1.1a4.65,4.65,0,0,1-2.16,3.59l-24.11,13.92c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,165.91,312.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,321.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,322.45,163.75,322.2,163.75,321.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,321.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,322.45,163.75,322.2,163.75,321.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.62,350c2.24-1.3,4.06-.25,4.06,2.34a9,9,0,0,1-4.06,7c-2.24,1.29-4.06.24-4.06-2.35A9,9,0,0,1,155.62,350Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,344.1,190,330.18c1.19-.69,2.16-.2,2.16,1.1a4.65,4.65,0,0,1-2.16,3.59l-24.11,13.92c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,165.91,344.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,353.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,354.45,163.75,354.2,163.75,353.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,353.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,354.45,163.75,354.2,163.75,353.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.62,367c2.24-1.3,4.06-.25,4.06,2.34a9,9,0,0,1-4.06,7c-2.24,1.29-4.06.24-4.06-2.35A9,9,0,0,1,155.62,367Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.91,361.1,190,347.18c1.19-.69,2.16-.2,2.16,1.1a4.65,4.65,0,0,1-2.16,3.59l-24.11,13.92c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,165.91,361.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,370.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,371.45,163.75,371.2,163.75,370.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,370.55a2.3,2.3,0,0,1,1.08-1.79l14.08-8.13c.6-.35,1.08-.1,1.08.54a2.31,2.31,0,0,1-1.08,1.8l-14.08,8.13C164.23,371.45,163.75,371.2,163.75,370.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5,345v.11c0,.33.23.47.52.3l23.33-13.47a1.15,1.15,0,0,0,.52-.9v-.11c0-.33-.23-.47-.52-.3L148,344.06A1.15,1.15,0,0,0,147.5,345Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.53,250.65l109.4-63.17c1.2-.69,2.17-.13,2.17,1.25v41.9a4.78,4.78,0,0,1-2.17,3.75l-109.4,63.17c-1.2.69-2.17.13-2.17-1.25V254.4A4.76,4.76,0,0,1,206.53,250.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.49,254.24c0,1.29,1,1.78,2.16,1.09l26.27-15.16a4.64,4.64,0,0,0,2.17-3.59c0-1.3-1-1.79-2.17-1.1l-26.27,15.16A4.67,4.67,0,0,0,212.49,254.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94,234.93c0,1.3,1,1.79,2.16,1.1l26.27-15.17a4.65,4.65,0,0,0,2.16-3.59c0-1.3-1-1.79-2.16-1.1L248.1,231.34A4.62,4.62,0,0,0,245.94,234.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.38,215.62c0,1.3,1,1.79,2.17,1.1l26.26-15.17A4.64,4.64,0,0,0,310,198c0-1.3-1-1.79-2.17-1.1L281.55,212A4.64,4.64,0,0,0,279.38,215.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.49,287.07c0,1.3,1,1.79,2.16,1.1l93.16-53.78a4.65,4.65,0,0,0,2.17-3.6c0-1.29-1-1.78-2.17-1.09l-93.16,53.78A4.65,4.65,0,0,0,212.49,287.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22,260.28l94-54.29c.95-.55,1.73-.1,1.73,1v14.76a3.83,3.83,0,0,1-1.73,3l-94,54.29c-.95.55-1.73.1-1.73-1V263.28A3.83,3.83,0,0,1,214.22,260.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.53,306.65l109.4-63.17c1.2-.69,2.17-.13,2.17,1.25v41.9a4.78,4.78,0,0,1-2.17,3.75l-109.4,63.17c-1.2.69-2.17.13-2.17-1.25V310.4A4.76,4.76,0,0,1,206.53,306.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.49,310.24c0,1.29,1,1.78,2.16,1.09l26.27-15.16a4.64,4.64,0,0,0,2.17-3.59c0-1.3-1-1.79-2.17-1.1l-26.27,15.16A4.67,4.67,0,0,0,212.49,310.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.94,290.93c0,1.3,1,1.79,2.16,1.1l26.27-15.17a4.65,4.65,0,0,0,2.16-3.59c0-1.3-1-1.79-2.16-1.1L248.1,287.34A4.62,4.62,0,0,0,245.94,290.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.38,271.62c0,1.3,1,1.79,2.17,1.1l26.26-15.17A4.64,4.64,0,0,0,310,254c0-1.3-1-1.79-2.17-1.1L281.55,268A4.64,4.64,0,0,0,279.38,271.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.49,343.07c0,1.3,1,1.79,2.16,1.1l93.16-53.78a4.65,4.65,0,0,0,2.17-3.6c0-1.29-1-1.78-2.17-1.09l-93.16,53.78A4.65,4.65,0,0,0,212.49,343.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.22,316.28l94-54.29c.95-.55,1.73-.1,1.73,1v14.76a3.83,3.83,0,0,1-1.73,3l-94,54.29c-.95.55-1.73.1-1.73-1V319.28A3.83,3.83,0,0,1,214.22,316.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5,166.37l-24.1,13.92a4.78,4.78,0,0,0-2.17,3.75v23.14c0,1.38,1,1.94,2.17,1.25l24.1-13.91a4.8,4.8,0,0,0,2.16-3.75V167.62C354.66,166.24,353.69,165.68,352.5,166.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.27,182.18c1.65-1,3-.18,3,1.72a6.59,6.59,0,0,1-3,5.17c-1.65,1-3,.18-3-1.72A6.62,6.62,0,0,1,333.27,182.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.41,182.71a2.33,2.33,0,0,1,1.09-1.8l10-5.78c.59-.35,1.08-.1,1.08.54a2.32,2.32,0,0,1-1.09,1.8l-10,5.79C338.9,183.6,338.41,183.36,338.41,182.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,192.64l18.14-10.48c.6-.34,1.09-.06,1.09.63v6.88a2.39,2.39,0,0,1-1.08,1.87L331.37,202c-.6.35-1.08.07-1.08-.62v-6.88A2.4,2.4,0,0,1,331.37,192.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5,199.21l-24.1,13.91a4.78,4.78,0,0,0-2.17,3.75v46.59c0,1.38,1,1.94,2.17,1.25l24.1-13.91a4.8,4.8,0,0,0,2.16-3.75V200.46C354.66,199.07,353.69,198.52,352.5,199.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.27,215c1.65-.95,3-.18,3,1.73a6.62,6.62,0,0,1-3,5.17c-1.65,1-3,.18-3-1.73A6.63,6.63,0,0,1,333.27,215Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.41,215.54a2.31,2.31,0,0,1,1.09-1.79l10-5.79c.59-.34,1.08-.1,1.08.55a2.33,2.33,0,0,1-1.09,1.8l-10,5.78C338.9,216.44,338.41,216.19,338.41,215.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,225.47,349.51,215c.6-.35,1.09-.07,1.09.62v6.88a2.43,2.43,0,0,1-1.08,1.88l-18.15,10.47c-.6.35-1.08.07-1.08-.62v-6.88A2.4,2.4,0,0,1,331.37,225.47Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.27,238.44c1.65-.95,3-.18,3,1.73a6.62,6.62,0,0,1-3,5.17c-1.65.95-3,.18-3-1.73A6.63,6.63,0,0,1,333.27,238.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.41,239a2.31,2.31,0,0,1,1.09-1.79l10-5.79c.59-.34,1.08-.1,1.08.55a2.31,2.31,0,0,1-1.09,1.79l-10,5.79C338.9,239.87,338.41,239.62,338.41,239Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,248.9l18.14-10.48c.6-.34,1.09-.06,1.09.63v6.88a2.43,2.43,0,0,1-1.08,1.88l-18.15,10.47c-.6.35-1.08.07-1.08-.62v-6.88A2.4,2.4,0,0,1,331.37,248.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5,255.48l-24.1,13.91a4.78,4.78,0,0,0-2.17,3.75v9.09c0,1.38,1,1.94,2.17,1.25l24.1-13.92a4.8,4.8,0,0,0,2.16-3.75v-9.08C354.66,255.35,353.69,254.79,352.5,255.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.28,270.43c1.64-.95,3-.18,3,1.73a6.6,6.6,0,0,1-3,5.16c-1.65,1-3,.18-3-1.72A6.6,6.6,0,0,1,333.28,270.43Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.42,271a2.32,2.32,0,0,1,1.08-1.8l10-5.78c.6-.35,1.08-.1,1.08.55a2.33,2.33,0,0,1-1.08,1.79l-10,5.79C338.9,271.86,338.42,271.61,338.42,271Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.78,118.22V106.14a3.8,3.8,0,0,0-1.73-3l-.6-.35a3.83,3.83,0,0,0-3.46,0l-150.9,87.12c-1,.55-1.73.1-1.73-1v-5.38a3.81,3.81,0,0,0-1.73-3l-.6-.35a3.83,3.83,0,0,0-3.46,0l-49.34,28.49a3.83,3.83,0,0,0-1.74,3v10.07a3.81,3.81,0,0,1-1.73,3l-4.66,2.69a3.85,3.85,0,0,0-1.73,3v12.07l4.06,2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.56,226.1H152l1.12-13.18L148,210a3.62,3.62,0,0,0-.51,1.71v10.07a3.58,3.58,0,0,1-.5,1.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.88,228.74a3.55,3.55,0,0,0-.51,1.7v12.07l4.06,2.35,4.07-11.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83,227.1l-4.66,2.69a3.82,3.82,0,0,0-1.74,3v12.07L362.78,118.22V106.15c0-1.11-.77-1.56-1.73-1l-155,89.46c-1,.55-1.73.11-1.73-1V183.54c0-1.11-.77-1.55-1.73-1L153.29,211a3.81,3.81,0,0,0-1.73,3V224.1A3.85,3.85,0,0,1,149.83,227.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.74,212c0,1.29,1,1.78,2.17,1.09L190,199.2a4.64,4.64,0,0,0,2.17-3.59c0-1.3-1-1.79-2.17-1.1l-24.1,13.92A4.64,4.64,0,0,0,163.74,212Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.65,213.2a4.49,4.49,0,0,0-2,3.52c0,1.29.91,1.82,2,1.17a4.49,4.49,0,0,0,2-3.52C159.68,213.08,158.77,212.55,157.65,213.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,193.76a.57.57,0,0,1-.25-.06L196,191.35a.5.5,0,1,1,.5-.86l4.06,2.34a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.24,196.11A.45.45,0,0,1,196,196a.49.49,0,0,1-.18-.68l4.06-7a.5.5,0,0,1,.86.5l-4.06,7A.5.5,0,0,1,196.24,196.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.56,234.5a.51.51,0,0,1-.44-.25.51.51,0,0,1,.19-.68l4.87-2.82a.5.5,0,0,1,.5.87l-4.87,2.81A.47.47,0,0,1,149.56,234.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.56,236a.45.45,0,0,1-.25-.07l-2.75-1.54,2.57-4.41a.5.5,0,0,1,.86.5L149.93,234l1.87,1a.5.5,0,0,1,.19.68A.49.49,0,0,1,151.56,236Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.78,230.31a.5.5,0,0,1-.25-.93l4.88-2.81a.5.5,0,0,1,.5.86L157,230.25A.54.54,0,0,1,156.78,230.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.66,231.29a.43.43,0,0,1-.25-.07.5.5,0,0,1-.18-.68l2.05-3.53-1.87-1a.51.51,0,0,1-.19-.68.5.5,0,0,1,.68-.19l2.75,1.54L160.09,231A.5.5,0,0,1,159.66,231.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,220.16l158.15-91.31c1.2-.69,2.17-.2,2.17,1.09a4.64,4.64,0,0,1-2.17,3.6L170,224.85c-1.2.69-2.16.2-2.16-1.1A4.62,4.62,0,0,1,170,220.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.38,124.08c1.12-.65,2-.12,2,1.17a4.49,4.49,0,0,1-2,3.52c-1.12.65-2,.12-2-1.17A4.49,4.49,0,0,1,336.38,124.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.5,119.39c1.13-.65,2-.12,2,1.17a4.48,4.48,0,0,1-2,3.52c-1.12.65-2,.12-2-1.17A4.49,4.49,0,0,1,344.5,119.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.63,114.7c1.12-.65,2-.12,2,1.17a4.49,4.49,0,0,1-2,3.52c-1.12.65-2,.12-2-1.17A4.49,4.49,0,0,1,352.63,114.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.19,155.83l-16.41,17s-16.11-1.59-21.58-3.16c-1.73-.49-3.12-2.85-3.5-4.84a2.5,2.5,0,0,0-1.92-2.2v4c-.14,1-.63,1.52-2.07,1.56-5.53.12-8.09-1.56-8.77,1.44-.43,1.92.41,4.1,4.06,5.1,5.13,1.41,8,.71,11.08,1.48,2.41.6,19.19,3.79,22.49,4.51,1.75.38,3.08.26,5-1.61s16.14-15.17,16.14-15.17c4.35-4.35,3.07-8.87.64-10.2C409.81,152.86,408.12,153.84,406.19,155.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.21,153.6c1.06.43,2.35,1.56,2.46,4.49s-2.06,5.58-4.61,8.62-3.31,3.85-3.31,3.85-6.45-2.34-7.54-7.13c0,0,4.86-5.14,6.31-6.79S408.65,152.47,411.21,153.6Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pointer--inject-1--inject-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.07,399.81l-33.29,2.6a1.37,1.37,0,0,0-1.24,1.35V406a2.2,2.2,0,0,0,1.12,1.81l21.16,10.4a.83.83,0,0,0,1.28-.69l.43-3.4a1.23,1.23,0,0,1,1.4-1.06l10.17,1.5a2.53,2.53,0,0,0,2-.76L289.7,412a3.87,3.87,0,0,0,.81-2.19v-2.2a1.49,1.49,0,0,0-1.23-1.43l-4.79-.71.92-.51a2.18,2.18,0,0,0,.91-1.76V401A1.13,1.13,0,0,0,285.07,399.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.07,399.81l-33.29,2.6a1.37,1.37,0,0,0-1.24,1.35V406a2.2,2.2,0,0,0,1.12,1.81l21.16,10.4a.83.83,0,0,0,1.28-.69l.43-3.4a1.23,1.23,0,0,1,1.4-1.06l10.17,1.5a2.53,2.53,0,0,0,2-.76L289.7,412a3.87,3.87,0,0,0,.81-2.19v-2.2a1.49,1.49,0,0,0-1.23-1.43l-4.79-.71.92-.51a2.18,2.18,0,0,0,.91-1.76V401A1.13,1.13,0,0,0,285.07,399.81Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54,403.76V406a2.2,2.2,0,0,0,1.12,1.81l21.16,10.4a1,1,0,0,0,.64.1V412.7l-21.68-10.29A1.37,1.37,0,0,0,250.54,403.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54,403.76V406a2.2,2.2,0,0,0,1.12,1.81l21.16,10.4a1,1,0,0,0,.64.1V412.7l-21.68-10.29A1.37,1.37,0,0,0,250.54,403.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.21,413.15a1.17,1.17,0,0,1,.72-.14l10.17,1.5a2.2,2.2,0,0,0,1-.12v-5.17l-11.89-1.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.21,413.15a1.17,1.17,0,0,1,.72-.14l10.17,1.5a2.2,2.2,0,0,0,1-.12v-5.17l-11.89-1.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.07,399.81l-33.29,2.6c-.68,0-.74.34-.12.65l21.16,10.4a.83.83,0,0,0,1.28-.68l.43-3.41a1.23,1.23,0,0,1,1.4-1.06l10.17,1.5a2.53,2.53,0,0,0,2-.76l1.55-1.78c.45-.53.26-1-.42-1.13l-10.17-1.5c-.69-.1-.75-.46-.15-.79l6.27-3.53C285.83,400,285.76,399.75,285.07,399.81Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.5dfe3645de48bcb7410b4a42dc59bb10.svg";
export { ForwardRef as ReactComponent };